import { Link, useLocation } from 'react-router-dom'
import { allRoutes } from '../../../routing/All_Routes'
import { constraintConfig } from '../../../../constraintConfig'
import { selectAuth } from '../../../../features/authSlice'
import { useAppSelector } from '../../../../hooks'

const QueryReportTabs = () => {
    const location = useLocation()
    const { roleID } = useAppSelector(selectAuth);

    return (
        <div className='card' style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
            <div className='d-flex overflow-auto h-55px px-10 border-bottom'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap'>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/expense-summary` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/expense-summary`}
                        >
                            Expense Summary
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/expense-detail` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/expense-detail`}
                        >
                            Expense Detail
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/expense-by-category` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/expense-by-category`}
                        >
                            Expense by Category
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/expense-violations` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/expense-violations`}
                        >
                            Expense Violations
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/category-budget` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/category-budget`}
                        >
                            Category Budget
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/export-expense` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/export-expense`}
                        >
                            Export Reports
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/user-report` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/user-report`}
                        >
                            User Report
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/user-cc-feeds` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/user-cc-feeds`}
                        >
                            User CC Feeds Report
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/report-ss-and-bc-data-match` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/report-ss-and-bc-data-match`}
                        >
                            Reconciliation Bank to BC Items Report
                        </Link>
                    </li>
                    <li className='nav-item'>
                        <Link
                            className={
                                `nav-link text-active-primary me-6 ` +
                                (location.pathname === `${allRoutes.analytics}/org-report/report-bank-and-bc-data-match` && 'active')
                            }
                            to={`${allRoutes.analytics}/org-report/report-bank-and-bc-data-match`}
                        >
                            SS To BC Sync Items Detail
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default QueryReportTabs